import Service from "./Service"

class NotificationService extends Service {

    findAllForCurrentUser = (queryParams) => this.getWithParams("/notifications", queryParams)

    getNotificationCount = () => this.get("/notifications/count")

    setSeen = (id, requestBody) => this.patch("/notifications/" + id, requestBody)
}

const notificationService = new NotificationService()
export default notificationService